module.exports = __webpack_public_path__ + "img/ball_5_black.7ef3b8d0.png";